import styled from 'styled-components';
import { primitives } from '@veneer/primitives';

const { typography, color } = primitives;

export const FeatureContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const FeatureItem = styled.div`
  font-family: ${typography.family0};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
  color: ${color.gray12};
  font-weight: ${typography.weight3};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80px;
  border-bottom: 1px solid ${color.gray12};
`;
